import { Form } from 'formik';
import styled from 'styled-components';

import {
  red,
  gray,
  black,
  green,
  lightGray,
  blue,
  lightBlue,
  whitesmoke,
  boxShadow1,
  border1,
} from 'utils/style/colors';

import Icon from 'components/Icon';
import HoverIcon from 'components/HoverIcon';

interface IQuestionIconProps {
  deleted: boolean;
}

export const FormContainer = styled(Form)`
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  position: relative;
  z-index: 2;
  background-color: var(--exact-white);
  border-radius: 1rem;
`;

export const SubmitForm = styled.div`
  margin: 10px;
  display: flex;
  justify-content: space-around;
`;

export const Delete = styled(HoverIcon)`
  align-self: center;
  margin: 1rem 0;
  margin-inline-end: 1rem;
`;

export const FieldArraysWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const QuestionIcon = styled(Icon)<IQuestionIconProps>`
  color: ${(props) => (props.deleted ? red : black)};
  padding-inline-end: 0.5rem;
`;

export const SurveyEditorHeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const VersionWrapper = styled('div')`
  background-color: ${whitesmoke};
  border-radius: 10px;
  padding: 0.5rem;
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
`;

export const Container = styled('div')`
  flex: 1;
  width: 100%;
  margin: 10px;
  display: flex;
  padding: 10px !important;
  min-width: 0;
  box-shadow: ${boxShadow1};
  overflow: visible;
  border-radius: 15px;
  transition: all 1s ease;
  flex-direction: column;
  background-color: var(--exact-white);
`;

export const NotifContainer = styled('div')`
  flex: 1;
  margin: 10px;
  display: flex;
  padding: 10px !important;
  min-width: 0;
  box-shadow: ${boxShadow1};
  overflow: visible;
  border-radius: 15px;
  transition: all 1s ease;
  background-color: var(--exact-white);
`;

export const IDContainer = styled('div')`
  flex: 1;
  margin: 10px;
  align-items: flex-start;
  justify-content: space-between;
  display: flex;
  padding: 10px !important;
  min-width: 0;
  box-shadow: ${boxShadow1};
  overflow: visible;
  border-radius: 15px;
  transition: all 1s ease;
  background-color: var(--exact-white);
`;

export const IndexOrderBadge = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 10rem;
  background-color: var(--exact-white);
  color: ${gray};
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${border1};
`;

export const ImportLabelExcel = styled.label`
  cursor: pointer;
  font-size: 1rem;
  color: var(--exact-white);
  background: ${black};
  padding: 0.8765rem 1rem;
  line-height: 1.375rem;
  display: block;
  border-radius: 0.5rem;
  &:hover {
    background: transparent;
    border: 1px solid ${black};
    color: ${black};
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;
`;

export const QuestionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.3rem;
  margin-bottom: 0.5rem;
`;

export const AddQuestion = styled.div`
  margin-top: 0.25rem;
`;

export const QuestionOptionsWithAnswer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 2rem;
  margin-inline-end: 1rem;
  gap: 0.5rem;
`;

export const Options = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const AQuestionOption = styled.div``;

export const Answer = styled.div`
  flex-grow: 0;
  text-align: center;
  padding: 0.25rem 0.5rem;
  border-radius: 10rem;
  background-color: ${green};
  font-size: 0.8rem;
`;

export const RepeatedQuestion = styled.div`
  color: var(--exact-white);
  text-align: center;
  padding: 0.25rem 0.5rem;
  border-radius: 10rem;
  background-color: ${red};
  font-size: 0.8rem;
`;

export const SaveButton = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const SelectedSectionItem = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 0.5rem;
  background: ${black};
  color: var(--exact-white);
  text-align: center;
`;

export const InstructionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InstructionsText = styled.div`
  font-weight: bold;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

export const ImportExcelContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 2rem 0;
`;

export const NotificationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  border: 1px solid ${blue};
  //background: ${lightBlue};
  border-radius: 1rem;
  padding: 1rem;
`;

export const NotificationBadgeContainer = styled.div`
  width: 5rem;
`;

export const NotificationContentContainer = styled.div`
  flex: 1;
  width: 100%;
  color: ${blue};

  & > * {
    color: ${blue};
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SelectedFileListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  gap: 1rem;
`;

export const ItemsWrapper = styled.div`
  width: 15rem;
  display: flex;
  height: 4rem;
  border-radius: 1rem;
  box-shadow: 1px 1px 4px ${lightGray};
`;

export const AttachedFileContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-inline-start: -3rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 1rem;
`;

export const PreviewTable = styled.table`
  overflow: scroll;

  & th {
    max-height: 3rem;
    background-color: #666;
    color: white;
  }
  & td,
  th {
    text-align: center;
    border: ${border1};
    // max-width: 200px;
  }
  & tr:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const ButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: 1rem;
`;

export const AIButton = styled.a`
  padding: 0.3rem 0.5rem;
  background: linear-gradient(
    96deg,
    rgb(66, 97, 253) 0%,
    rgb(244, 75, 109) 100%
  );
  border-radius: 15px;
  color: var(--exact-white);
  box-shadow: ${boxShadow1};

  display: flex;
  gap: 0.5rem;
  align-items: center;
  cursor: ${(props) => (props.disable ? 'not-allowed' : 'pointer')};
`;
